'use strict';

module.exports = {
    SINGLE: 'SINGLE',
    PAY_WITH_GUARANTEE: 'PAY_WITH_GUARANTEE',
    PAY_WITH_GUARANTEE_NORMAL: 'PAY_WITH_GUARANTEE_NORMAL',
};
